var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21h14c.552 0 1-.448 1-1V9.751L14.092 3H5c-.552 0-1 .448-1 1v16c0 .552.448 1 1 1zM15 1l7 8v11c0 1.657-1.343 3-3 3H5c-1.657 0-3-1.343-3-3V4c0-1.657 1.343-3 3-3h10z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.928 13.437l-2.144-.814 2.144-.828V10.17L5.75 12.028v1.173l4.178 1.862v-1.626zm-.223 2.76h1.37l2.7-7.447h-1.371l-2.7 7.448zm3.97-4.416l2.247.825-2.248.844v1.603l4.297-1.85v-1.177l-4.297-1.85v1.604z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHtml);
export default __webpack_public_path__ + "static/media/ic_html.cbb31ae2a28f93a1c6200ad160ddac2d.svg";
export { ForwardRef as ReactComponent };